export default __webpack_public_path__ + "static/src/assets/images/icons/wrong_icon.png";